var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 10,
    id: "line_svg__HJARZIaGZf"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes Bk1xRb8aGbfAnimation{0%,to{opacity:1}50%{opacity:.35}}")), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 10,
    id: "line_svg__HJARZIaGZf"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 10,
    fillRule: "evenodd",
    rx: 5,
    style: {
      transformOrigin: "50% 50%",
      animation: "Bk1xRb8aGbfAnimation 1s infinite linear"
    },
    fill: "#ccc"
  })));
}
export default SvgLine;